/**
 * Makes the header's Shop Now button add the product on screen to the cart.
 *
 * It forwards the click to the product form's own add-to-cart button rather than posting to
 * /cart/add itself, so the selected variant, the selling plan and the add-ons all come along, and
 * the cart drawer opens the way it does everywhere else. Only loaded on the product pages the
 * header section is configured for.
 */
(() => {
  const button = document.querySelector('[data-td-header-atc]');
  if (!button) return;

  // Re-queried on every use: switching variant re-renders the buy buttons, replacing the element.
  const getProductButton = () => document.querySelector('[data-td-product-atc]');

  const sync = () => {
    const productButton = getProductButton();
    button.disabled = !productButton || productButton.disabled;
  };

  button.addEventListener('click', () => {
    const productButton = getProductButton();
    if (!productButton || productButton.disabled) return;

    productButton.click();
  });

  // The buy buttons are re-rendered on variant change, which can flip the sold out state.
  document.addEventListener('product:rerender', () => requestAnimationFrame(sync), true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
